import { post } from './http'
export const getCode = v => post('/api/admin/code', v);
export const doLOgin=v=>post('/api/admin/doLogin', v)
export const getCustomerInfo=v=>post('/api/wlive/getCustomerInfo', v)